import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { dateFormat } from '../../../../util/date.js';
import { truncate, nl2br } from '../../../../util/text.js';

import { REVIEW_SCORE_MAX } from '../../ReviewActions.js';

import HtmlComponent from '../../../../components/Text/HtmlComponent.js';

function ReviewListItem({ review, isSummary = false }) {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	const text = isSummary ? `${truncate(review.text)}...` : review.text;
	const initial = (review.name || '?').trim().charAt(0).toUpperCase();

	return (
		<div className="h-100 mb-2 p-3 bg-white border rounded-3 d-flex flex-column gap-2 text-start" style={{ fontSize: '0.85rem' }}>
			<div className="d-flex align-items-center gap-2">
				<span className="d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-circle bg-light text-dark fw-bold" style={{ width: '34px', height: '34px' }}>{initial}</span>
				<div className="lh-sm">
					<strong className="d-block text-dark">{review.name}</strong>
					<span className="small text-muted">{dateFormat(review.dates.creation, 'DD/MM/YYYY')}</span>
				</div>
				<span className="ms-auto small fw-bold text-success text-nowrap">✔ <FormattedMessage id="reviewVerifiedPurchase" defaultMessage="Verified purchase" /></span>
			</div>

			{mounted && review.score > 0 && (
				<div className="starRating starRatingSmall">
					<div style={{ width: `${(review.score * 100) / REVIEW_SCORE_MAX}%` }}>{' '}</div>
				</div>
			)}

			{review.title && <strong className="text-danger">{review.title}</strong>}

			<div className="text-body"><HtmlComponent text={nl2br(text)} /></div>

			{!isSummary && review.answer && (
				<div className="mt-1 pt-2 border-top">
					<span className="d-block fw-bold small text-muted"><FormattedMessage id="reviewAnswer" defaultMessage="Answer" /></span>
					<div className="small" style={{ overflow: 'auto', maxHeight: '200px' }}>{review.answer}</div>
				</div>
			)}
		</div>
	);
}

ReviewListItem.defaultProps = {
	isSummary: false,
};

ReviewListItem.propTypes = {
	review: PropTypes.object.isRequired,
	isSummary: PropTypes.bool,
};

export default ReviewListItem;
